import { useSelector } from 'react-redux'
import { selectTypeFontSize } from '../../../app/slice'

export const UseTypeFontSize = () => {
  const typeFontSize = useSelector(selectTypeFontSize)

  return typeFontSize
}
